<!--Wrapper Start-->
<div style="background: #101e2a;">
  <div class="d-flex" id="wrapper">

    <!-- Sidebar -->
    <div class="pr-4 pt-4" id="sidebar-wrapper" *ngIf="showSideMenu">
      <button id="close_sidebar"><img src="assets/images/close.png" width="16" alt="Close Button Image"></button>
      <span class="sidebar-logo">
        <img class="pointer" src="/assets/images/bars.png" (click)="showSideMenuFn()" alt="Line Bars Image" width="27"/>
        <img src="assets/images/logo.png" alt="Site Logo" width="200" style="margin-left:7px;"/>
      </span>
      <div class="list-group list-group-flush mt-5">
        <a routerLink="/image-editor" routerLinkActive="active">CREATE TEMPLATE</a>
        <a routerLinkActive="active" id="toggle_menu" routerLink="/panel">READY-MADE TEMPLATES <img src="assets/images/angle_down.png" class="angle_down" width="10" alt="Angle Down Image"></a>
        <a routerLinkActive="active" id="toggle_menu" routerLink="/users" *ngIf="isAdmin">USERS LIST</a>
        <a (click)="addCategory()" class="pointer" *ngIf="isAdmin">
          <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; CREATE CATEGORY
        </a>
        <div class="drop_menu">
          <a class="dropdown-item pointer" *ngFor="let type of allTemplatesType" >
            <i class="fa fa-pencil-square-o" aria-hidden="true" (click)="editClick(type)" *ngIf="isAdmin"></i>&nbsp;
            <i class="fa fa-trash" aria-hidden="true" (click)="deleteCategory(type.id)" *ngIf="isAdmin"></i> &nbsp;&nbsp;
            <span (click)="typeselect(type.id)">{{type.name}}</span>
          </a>
        </div>
      </div>
    </div>
    <!-- /#sidebar-wrapper -->

    <!-- Page Content -->
    <div id="page-content-wrapper">

      <nav class="navbar navbar-expand-lg navbar-light pb-4">
        <button class="btn btn-primary" id="menu-toggle" (click)="showSideMenuFn()"><img src="assets/images/bars.png" alt="Line Bars Image" *ngIf = "!showSideMenu"></button>
        <div class="" style="padding-left:80%">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0" style="display:inline-block">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle pr-0"  id="navbarDropdown" role="button" (click)="showMenuFn()">
                <img src="assets/images/user.png" width="50" class="img-fluid" alt="User Image">
              </a>
              <div class="dropdown-menu dropdown-menu-right" style="display:block;" *ngIf="showMenu">
                <a class="dropdown-item" href="#"><img src="assets/images/settings.png" alt="Settings Image" width="20">Setting</a>
                <a class="dropdown-item" (click)="Logout()"><img src="assets/images/logout.png" alt="Logout Image" width="20">Log Out</a>
              </div>
            </li>
          </ul>
          <div style="color: #fff; margin-left:7px;display: inline-block;max-width: 130px;word-break: break-word">{{userLogged.name}}</div>
        </div>
      </nav>

      <div class="container-fluid" *ngIf="containerShowing == 'subtypes'">
        <div class="row" *ngIf="allTemplatesSubtype && allTemplatesSubtype.length !=0 ">
          <div class="col-lg-4 p-1" *ngFor="let sub of allTemplatesSubtype">
            <a class="pointer" *ngIf="!isAdmin" routerLink="/image-editor/{{sub.id}}/{{sub.imagePath}}">
              <img src="{{sub.img}}" class="position-relative d-flex" style="height:125px;width: 100%;">
            </a>
            <img src="{{sub.img}}" *ngIf="isAdmin" class="position-relative d-flex" style="height:125px;width: 100%;">
            <div class="btn-group" role="group" *ngIf="isAdmin" style="width:100%;">
              <a class="btn btn-info" routerLink="/image-editor/{{sub.id}}/{{sub.imagePath}}" >Edit</a>
              <a class="btn btn-danger" (click)="deleteTemplate(sub.id)">Delete</a>
            </div>
          </div>
        </div>
        <span *ngIf="pagination.size>=pagination.limit" style="float: right;color: #fff;background: none;padding: 10px;cursor:pointer;" (click)="loadMore()">Load More...</span>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
</div>
